import { apiClient } from './apiClient';

export interface PartnershipDetail { label: string; value: string; icon?: string }
export interface PartnershipDto { id: string; brandName: string; brandLogo?: string; artistName?: string; status: string; details: PartnershipDetail[] }

export async function listPartnerships() {
  const data = await apiClient.get<{ items: PartnershipDto[] }>(`/partnerships`);
  return data.items;
}

export async function createPartnership(payload: { brandName: string; brandLogo?: string; artistId?: string; status: string; details: PartnershipDetail[] }) {
  return apiClient.post(`/partnerships`, payload);
}

export async function deletePartnership(id: string) {
  return apiClient.delete(`/partnerships/${id}`);
}

export async function updatePartnership(id: string, patch: Partial<{ brandName: string; brandLogo?: string; artistId?: string; status: string; details: PartnershipDetail[] }>) {
  return apiClient.patch(`/partnerships/${id}`, patch);
}
